import type { ReactNode } from 'react';
import { translateSelector } from '@ackee/jerome';
import { ConfigProvider } from 'antd';
import { IntlProvider } from 'react-intl';
import { useSelector } from 'react-redux';

import type { Language } from '../../contants';
import { antdData, intlData } from '../../translations';

export interface LocalizationsProviderProps {
    children: ReactNode;
}

export const LocalizationsProvider = ({ children }: LocalizationsProviderProps) => {
    const { locale } = useSelector(translateSelector);

    return (
        <IntlProvider locale={locale} messages={intlData[locale as Language]}>
            <ConfigProvider locale={antdData[locale as Language]}>{children}</ConfigProvider>
        </IntlProvider>
    );
};
